import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=9381d64e&scoped=true"
import script from "./GroupPanel.vue?vue&type=script&lang=ts"
export * from "./GroupPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9381d64e",
  null
  
)

export default component.exports